import {GlobalVariables} from "../GlobalVariables";

export default class Footer {
	static init() {
		this.header = document.querySelector(".header-main");
		this.footer = document.querySelector(".footer-main");
		this.footerDetection();
	}

	static footerDetection() {
		if (!this.footer || !this.header) return;

		const updateOffset = () => {
			const footerHeight = this.footer.offsetHeight;
			this.header.style.setProperty('--footer-offset', `${footerHeight + 18}px`);
		};

		const observer = new IntersectionObserver((entries) => {
			if (entries[0].isIntersecting) {
				updateOffset();
				this.header.classList.add("footer-in-view");
			} else {
				this.header.classList.remove("footer-in-view");
			}
		}, {
			rootMargin: "0px 0px 100px 0px",
			threshold: 0
		});

		observer.observe(this.footer);

		window.addEventListener('resize', () => {
			if (this.header.classList.contains('footer-in-view')) {
				updateOffset();
			}
		});
	}
}
